import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FileText } from 'lucide-react';

// Remaining proposal allowance for the current billing month (hidden for unlimited plans / founding account).
export const ProposalAllowance = ({ refreshKey }) => {
  const [u, setU] = useState(null);
  useEffect(() => { axios.get('/billing/usage').then((r) => setU(r.data)).catch(() => setU(null)); }, [refreshKey]);
  if (!u || u.limit === null || u.limit === undefined) return null;
  const pct = Math.min(100, Math.round((u.used / u.limit) * 100));
  const tone = u.exhausted ? '#dc2626' : u.remaining <= 5 ? '#d97706' : '#4f46e5';
  const resets = new Date(u.resets_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  return (
    <div data-testid="proposal-allowance" title={`${u.plan_name}: ${u.used} of ${u.limit} proposals used this billing month`}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 10, padding: '6px 12px', borderRadius: 999, background: '#f8fafc', border: `1px solid ${tone}33`, fontSize: 13, color: '#0f172a' }}>
      <FileText size={14} style={{ color: tone }} />
      <span data-testid="proposal-allowance-text"><b style={{ color: tone }}>{u.remaining}</b> of {u.limit} proposals left this billing month</span>
      <span style={{ width: 72, height: 6, borderRadius: 3, background: '#e2e8f0', overflow: 'hidden' }}><span style={{ display: 'block', width: `${pct}%`, height: '100%', background: tone }} /></span>
      <span style={{ fontSize: 11, color: '#64748b' }}>resets {resets}</span>
    </div>
  );
};
